import React, { useEffect, useState } from 'react';
import {
	NavigationStepperComponentParams,
	NavigationStepperItemType,
} from '../../../../Components/Stepper/NavigationStepper';
import { usePatientTreatmentContext } from './ContextProvider';
import { useAppContext } from '../../../../Services/AppContext';
import WorkplaceCalendar from '../../../../Components/Calendar/WorkplaceCalendar';
import EventsList from '../../../../Components/Events/EventsList';
import SubTabNavigationStepper from '../../../../Components/Stepper/SubTabNavigationStepper/SubTabNavigationStepper';
import { useAclContext } from '../../../Acl/Components/AclContextProvider';
import PatientTreatmentPageWrapper from './PatientTreatmentPageWrapper';

interface PatientTreatmentPrescriptionProps {}

const PatientTreatmentCalendar: React.FC<
	PatientTreatmentPrescriptionProps
> = props => {
	const { patientId } = usePatientTreatmentContext();
	const { workplaceId } = useAppContext();
	const [stepParams, setStepParams] = useState({});
	const [steps, setSteps] = useState<NavigationStepperItemType[]>([]);
	const { isAllowed } = useAclContext();

	const handleShowInCalendar = (
		a: string,
		b: { params: any },
		params: NavigationStepperComponentParams,
	) => {
		console.log({ bParams: b.params });
		console.log({ bParams: b.params });
		params.setActiveStepPath(a);
		setStepParams(b.params);
	};

	useEffect(() => {
		const tempSteps: NavigationStepperItemType[] = [];

		if (isAllowed('calendar')) {
			tempSteps.push({
				name: 'patientTreatment.orders.order.title',
				key: 'order',
				component: () => (
					<WorkplaceCalendar
						workplaceId={workplaceId}
						patientId={patientId}
						params={stepParams}
					/>
				),
			});
		}

		tempSteps.push({
			name: 'patientTreatment.orders.patientsOrders.title',
			key: 'patientsOrders',
			component: (params: NavigationStepperComponentParams) => (
				<PatientTreatmentPageWrapper patientId={patientId}>
					<EventsList
						patientId={patientId}
						workplaceId={workplaceId}
						onShowInCalendar={(a: string, b: { params: any }) =>
							handleShowInCalendar(a, b, params)
						}
					/>
				</PatientTreatmentPageWrapper>
			),
		});

		setSteps(tempSteps);
	}, [stepParams]);

	if (!steps.length) {
		return <></>;
	}

	return (
		<>
			<SubTabNavigationStepper
				steps={steps}
				initialStepPath='order'
				canSkip={true}
			/>
		</>
	);
};

export default PatientTreatmentCalendar;
